export default __webpack_public_path__ + "assets/moon-waxing-crescent.6de8c45d.svg";